import withStore from 'store/StoreContainer';
import {
  getDraftById,
  generateDraftFromBook,
  generateDraftFromOrder,
  goToRoot,
  draftStateSelector,
  draftIdSelector,
  draftNameSelector,
  draftMilestoneSelector,
  draftUpdatedAtSelector,
} from 'modules/v2/draft/store';

const mapStateToProps = (state) => ({
  draft: draftStateSelector(state),
  draftUpdatedAt: draftUpdatedAtSelector(state),
  draftId: draftIdSelector(state),
  milestone: draftMilestoneSelector(state),
  draftName: draftNameSelector(state),
});

const mapDispatchToProps = {
  getDraftById,
  generateDraftFromBook,
  generateDraftFromOrder,
  goToRoot,
};

export default withStore(mapStateToProps, mapDispatchToProps);
